import React, { useEffect, useState } from 'react';
import Banner from '../../Components/Banner';
import { useParams } from 'react-router';
import { DatesSelectionType } from '../../Components/Types';
import ReactGA from "react-ga4";
import { AvailabilityContainer, FullCalenderContainer } from 'Components/Calendar/CalendarComponents';
import CalendarContainer from './CalendarContainer';
import { useDispatch } from 'react-redux';
import { setCurrentBooking } from 'features/Booking-Slice';
import { isValidHandoverDate } from 'Components/DateUtils';
import { BankHolidaysAPI } from 'API/CalendarAPI';
import Loader from 'Components/Loader';

function CheckAvailabilityPage() {
    const { mhid } = useParams<{ mhid: string }>();
    const dispatch = useDispatch();
    const params = new URLSearchParams(window.location.search);
    const hasUrlParams = params.get('start') && params.get('end');
    const [bankHolidays, setBankHolidays] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(!!hasUrlParams);
    const [datesSelection, setDatesSelection] = useState<DatesSelectionType>({
        'vehicle_id': parseInt(mhid ? mhid : ""),
        'start_date':  '',
        'end_date': ''
    });
    
    dispatch(setCurrentBooking(null));
    
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        const loadBankHolidays = async () => {
            const bhDates = await BankHolidaysAPI.get();
            setBankHolidays(bhDates);
        };
        loadBankHolidays();
    }, []);

    useEffect(() => {
        if (bankHolidays.length > 0) {
            const urlParams = new URLSearchParams(window.location.search);
            var startDate = verifyDate(urlParams.get('start'), bankHolidays);
            var endDate = verifyDate(urlParams.get('end'), bankHolidays);
            setDatesSelection({
                'vehicle_id': parseInt(mhid ? mhid : ""),
                'start_date': startDate,
                'end_date': endDate
            });
            setIsLoading(false);
        }
    }, [bankHolidays, mhid]);

    const verifyDate = (value: string | null, holidays: string[]): string => {
        if (!!value) {
            try {
                const date = new Date(value);
                if (isValidHandoverDate(date, holidays)) {
                    return value;
                }
            } catch {}
        }
        return "";
    }

    if (isLoading) {
        return <Loader />;
    }

    return (
        <>
            <Banner mainText="Check Availability" />
            <AvailabilityContainer>
                <FullCalenderContainer>
                   <CalendarContainer datesSelection={datesSelection && datesSelection} />
                </FullCalenderContainer>
            </AvailabilityContainer>
        </>

    );
}
export default CheckAvailabilityPage;
